import { apiFetch, ApiError } from './api-client';

export interface NfcClaimResult {
  ok: true;
  quantity: number;
  shop: string;
  firstVisit: boolean;
  birthday: { title: string; bonus: number } | null;
}

export async function claimNfcStamp(params: { uid: string; ctr: string; cmac: string }): Promise<NfcClaimResult> {
  return apiFetch<NfcClaimResult>('/api/stamp', { action: 'nfc-tap', ...params });
}

export { ApiError };
